module.exports = __webpack_public_path__ + "hyundai.377e54832d09adc4c831.png";